import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { EmergencyProvider } from "@/components/EmergencyProvider";
import { CartProvider } from "@/components/CartProvider";
import { Layout } from "@/components/Layout";

import Home from "@/pages/Home";
import Resources from "@/pages/Resources";
import TeenFacts from "@/pages/TeenFacts";
import StormWatchers from "@/pages/StormWatchers";
import { LangProvider } from "@/lib/lang";
import Stories from "@/pages/Stories";
import Affirmations from "@/pages/Affirmations";
import SuperKids from "@/pages/SuperKids";
import Sanctuary from "@/pages/Sanctuary";
import Lantern from "@/pages/Lantern";
import Shop from "@/pages/Shop";
import Donations from "@/pages/Donations";
import Journal from "@/pages/Journal";
import Stay from "@/pages/Stay";
import Speaking from "@/pages/Speaking";
import About from "@/pages/About";
import Mission from "@/pages/Mission";
import Training from "@/pages/Training";
import { STORE_VISIBLE } from "@/lib/flags";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import MerchPreview from "@/pages/MerchPreview";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  return (
    <div className="App">
      <LangProvider>
      <BrowserRouter>
        <EmergencyProvider>
          <CartProvider>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/training" element={<Training />} />
                <Route path="/stories" element={<Stories />} />
                <Route path="/affirmations" element={<Affirmations />} />
                <Route path="/super-kids" element={<SuperKids />} />
                <Route path="/teen-facts" element={<TeenFacts />} />
                <Route path="/storm-watchers" element={<StormWatchers />} />
                <Route path="/sanctuary" element={<Sanctuary />} />
                <Route path="/lantern/:code" element={<Lantern />} />
                <Route path="/shop" element={STORE_VISIBLE ? <Shop /> : <Navigate to="/" replace />} />
                <Route path="/donations" element={STORE_VISIBLE ? <Donations /> : <Navigate to="/" replace />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/stay" element={<Stay />} />
                <Route path="/speaking" element={<Speaking />} />
                <Route path="/about" element={<About />} />
                <Route path="/mission" element={<Mission />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/legal" element={<Legal />} />
                <Route path="/merch-preview" element={STORE_VISIBLE ? <MerchPreview /> : <Navigate to="/" replace />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Routes>
            </Layout>
            <Toaster position="top-center" richColors />
          </CartProvider>
        </EmergencyProvider>
      </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
